import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { TravelAdvisorProfile } from '../travel-advisor-profile.model';
import { TravelAdvisorProfileServiceFactory, TravelAdvisorProfileService } from '../travel-advisor-profile.service';
import { User } from '../user.model';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-detail-destinations',
  templateUrl: './user-detail-destinations.component.html',
  styleUrls: ['./user-detail-destinations.component.css']
})
export class UserDetailDestinationsComponent implements OnInit {

  constructor(private route: ActivatedRoute, private userService: UserService, private authService: AuthService, private profileServiceFactory: TravelAdvisorProfileServiceFactory, private snackBar: MatSnackBar) { }

  user: User;

  private isNew = false;
  profileService: TravelAdvisorProfileService;
  profile: TravelAdvisorProfile;

  async ngOnInit() {
    if (this.route.snapshot.parent.params.userId) {
      this.user = await this.userService.get(this.route.snapshot.parent.params.userId).pipe(first()).toPromise();
    } else {
      this.user = await this.authService.user$.pipe(first()).toPromise();
    }

    this.profileService = this.profileServiceFactory.create(this.user.id);

    this.profile = await this.profileService.get("default").pipe(first()).toPromise();
    if (!this.profile.id) {
      this.profile = new TravelAdvisorProfile({ id: "default" });
      this.isNew = true;
    }
    this.applySchemaUpgrades();
  }

  private applySchemaUpgrades() {
    if (!this.profile.destinations) {
      this.profile.destinations = {
        nations: []
      };
    }
  }

  save() {

    (this.isNew ? this.profileService
      .create(this.profile) : this.profileService
        .update(this.profile))

      .then(() => {
        this.isNew = false;
        this.snackBar.open("Profilo salvato 😉", null, {
          duration: 1000
        });
      })
      .catch((e) => {
        console.error(e);
        this.snackBar
          .open("Errore durante il salvataggio del profilo 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.save();
          });
      });
  }

}
